const puzzle = {
  id: "nC4m7jM84JVA1UsyQCAe",
  name: "Ancient Accounting",
  rebuses: [
    {
      clues: [
        {
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "fec04637-5dee-4f08-a2ae-021af379a01e",
              value: "YUruWpD9.png",
              type: "image",
              subtext: "",
            },
          ],
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            type: "text",
            solvedText: "Pinky",
            possibleSolutions: [
              {
                id: "43fdd3c9-15d6-4a76-8af0-fe4390ef7985",
                value: "Pinky",
              },
            ],
          },
          id: "0220f308-31dc-489a-9260-d2ad435ec23b",
          dependsOn: [],
          helperText:
            "A cartoon about two rats. The second one's name is Brain.",
        },
        {
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Ring",
                id: "e1de24d4-1773-405e-ab88-e560776e67e8",
              },
              {
                value: "Rings",
                id: "900fd41f-a954-4a54-a1b4-8792c6ddd00c",
              },
            ],
            solvedText: "Ring",
          },
          clueGroup: 0,
          clueValues: [
            {
              value: "Olympics - 5",
              subtext: "",
              type: "text",
              id: "a8d0d37b-6d03-4c48-9d8c-56ae990ed405",
              style: {
                width: "calc(100% - 10px)",
              },
            },
            {
              value: "Audi - 4",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              subtext: "",
              id: "e8b59520-0eba-4105-8ec2-1a7f1a2493f4",
            },
            {
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "62dde978-6180-4281-881c-a12f9d6edd37",
              type: "text",
              value: "Krupp - 3",
            },
          ],
          dependsOn: [],
          helperText: "You wear it on your hand",
          subtext: "",
          id: "ac1b453c-bb0d-4a46-8f9a-b7abffc1116f",
          style: {
            width: "calc(33% - 10px)",
          },
        },
        {
          clueGroup: 0,
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              value: "MiddleVennDiagram",
              id: "56d4ffc2-ba54-44ea-b04d-08a6384cdb77",
              subtext: "",
              type: "customComponent",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "19a3b33f-714f-4fe8-b682-beb2cbeac4c6",
          helperText: "Between left and right. You'll find Malcolm there.",
          dependsOn: [],
          solutionInfo: {
            solvedText: "Middle",
            type: "text",
            possibleSolutions: [
              {
                id: "7ec3c79b-4e54-4369-91d1-820f9c32c1b4",
                value: "Middle",
              },
            ],
          },
        },
      ],
      id: "e86ff98c-b3c5-444b-9cbf-953201ea203c",
      solutionInfo: {
        solvedText: "Finger",
        type: "text",
        possibleSolutions: [
          {
            id: "c7c60783-196a-4816-9b6a-db652f69c155",
            value: "Finger",
          },
          {
            value: "Fingers",
            id: "0a4e5897-34c7-4877-a51c-9156c35fd3f1",
          },
        ],
      },
      style: {},
    },
    {
      solutionInfo: {
        possibleSolutions: [],
        type: "text",
        solvedText: "Tadpole",
      },
      style: {},
      clues: [
        {
          dependsOn: [],
          clueGroup: 0,
          style: {
            width: "calc(14% - 10px)",
          },
          id: "9787a465-0c2d-4f9f-9363-9c1fb5063979",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          subtext: "",
          helperText:
            "Cross looks like the letter t. What do other objects look like?",
          clueValues: [
            {
              id: "96cf173e-9cc8-4c4e-beaf-d66b592b1617",
              style: {
                minHeight: "190px",
                width: "calc(100% - 10px)",
              },
              subtext: "t",
              value: "Cross",
              type: "text",
            },
          ],
        },
        {
          id: "586aceec-19b7-470a-8062-5f8c7f76e325",
          style: {
            width: "calc(14% - 10px)",
          },
          clueValues: [
            {
              subtext: "?",
              type: "text",
              value: "Eiffel Tower",
              style: {
                width: "calc(100% - 10px)",
                minHeight: "190px",
              },
              id: "43829d24-8ad4-49c2-b10a-e63156cf1eb2",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          helperText: "What letter does the Eiffel Tower look like?",
          solutionInfo: {
            type: "text",
            solvedText: "A",
            possibleSolutions: [
              {
                value: "A",
                id: "4ece3cc4-a543-4b61-a118-a712916ac34c",
              },
            ],
          },
        },
        {
          helperText: "What letter does a bow look like?",
          style: {
            width: "calc(14% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            possibleSolutions: [
              {
                id: "e7c9ca8c-f7e6-4011-b696-6c78e5859726",
                value: "D",
              },
            ],
            solvedText: "D",
            type: "text",
          },
          subtext: "",
          clueValues: [
            {
              value: "Bow",
              subtext: "?",
              type: "text",
              style: {
                minHeight: "190px",
                width: "calc(100% - 10px)",
              },
              id: "f7139dce-34e2-4ff4-a39a-4eec6c69ebd2",
            },
          ],
          id: "ac1f5d28-11e4-49eb-9dd3-f07a40e03f9a",
          clueGroup: 0,
        },
        {
          subtext: "",
          id: "35629ebe-09b3-45a5-a5c2-79f708455f8f",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "a936c30e-9e4f-4fa3-b1ff-acf979aa30cf",
                value: "P",
              },
            ],
            type: "text",
            solvedText: "P",
          },
          helperText: "What letter does a flag on a stick look like?",
          clueGroup: 0,
          clueValues: [
            {
              subtext: "?",
              id: "9919b727-244c-43cd-a26a-1e4fc87bf1c4",
              style: {
                width: "calc(100% - 10px)",
                minHeight: "190px",
              },
              type: "text",
              value: "Flag on a stick",
            },
          ],
          dependsOn: [],
          style: {
            width: "calc(14% - 10px)",
          },
        },
        {
          dependsOn: [],
          style: {
            width: "calc(14% - 10px)",
          },
          helperText: "What letter does the Earth look like?",
          id: "689b94f5-ad33-4674-b7d1-4090f182366e",
          clueGroup: 0,
          solutionInfo: {
            type: "text",
            solvedText: "O",
            possibleSolutions: [
              {
                id: "ca676c24-25c5-45ad-9b5a-a81ba71a8237",
                value: "O",
              },
            ],
          },
          clueValues: [
            {
              type: "text",
              id: "445d67e7-86cf-41e5-a94c-ced577672b45",
              style: {
                minHeight: "190px",
                width: "calc(100% - 10px)",
              },
              value: "Earth",
              subtext: "?",
            },
          ],
          subtext: "",
        },
        {
          dependsOn: [],
          subtext: "",
          helperText:
            "What letter does a left bottom corner of a frame look like?",
          id: "812c3002-5a07-44e4-aadc-6c220a7c67f9",
          solutionInfo: {
            type: "text",
            solvedText: "L",
            possibleSolutions: [
              {
                id: "c4efab34-69c6-41f9-9a8c-b4ca8e33fab8",
                value: "L",
              },
            ],
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
                minHeight: "190px",
              },
              id: "343f4443-5871-42af-94a8-740ea0fa8c4a",
              value: "Corner of a frame",
              type: "text",
              subtext: "?",
            },
          ],
          style: {
            width: "calc(14% - 10px)",
          },
          clueGroup: 0,
        },
        {
          clueValues: [
            {
              id: "d4a8444c-a72d-4769-978a-b5e822f32126",
              style: {
                width: "calc(100% - 10px)",
                minHeight: "190px",
              },
              subtext: "?",
              type: "text",
              value: "Traffic light from a side",
            },
          ],
          clueGroup: 0,
          id: "978e6e3b-47be-4962-aa8a-987b93990b07",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "d4e25258-bae3-4cf7-ac9a-dc23bf64e7c5",
                value: "E",
              },
            ],
            solvedText: "E",
            type: "text",
          },
          helperText: "What letter does a traffic light from a side look like?",
          style: {
            width: "calc(14% - 10px)",
          },
          subtext: "",
          dependsOn: [],
        },
      ],
      id: "72e9bfc0-0ab7-43b0-9af4-98702eaa1d89",
    },
    {
      style: {},
      clues: [
        {
          helperText:
            "He doesn't use it while climbing. It's a good thing to use while climbing.",
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 0,
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueValues: [
            {
              type: "text",
              subtext: "doesn’t use it",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "7fe57e5d-1497-49d5-80d9-112b054821bf",
              value: "Alex Honnold",
            },
          ],
          id: "971e2765-2190-4814-bb71-f980f2fe8649",
          dependsOn: [],
          subtext: "",
        },
        {
          clueGroup: 0,
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueValues: [
            {
              id: "00dfe6a9-90f0-4f6b-9058-fc5a4e457a71",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Albert Pierrepoint",
              subtext: "used it a bit too much",
              type: "text",
            },
          ],
          helperText:
            "You use it in public executions. You don't want to wrap your head around that.",
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "052dcf51-27f2-4086-8721-bbb9f8fc94ba",
          dependsOn: [],
        },
      ],
      solutionInfo: {
        solvedText: "Rope",
        type: "text",
        possibleSolutions: [
          {
            id: "9474d532-c8bd-4395-9786-67d208352287",
            value: "Rope",
          },
        ],
      },
      id: "a529e767-73ee-4d62-8bef-e6286253e218",
    },
    {
      solutionInfo: {
        possibleSolutions: [
          {
            value: "Egypt",
            id: "59e7de37-f651-4e04-98e8-45de8a8f4729",
          },
          {
            id: "cad4d66a-7c1b-4438-8f25-abc5f45c705b",
            value: "Egyptian numbers",
          },
          {
            id: "b79e72f7-de57-46a1-9a35-126c013f0b79",
            value: "Egyptian Number System",
          },
          {
            value: "Egyptian Numerals",
            id: "69f5650f-07ce-442b-8d8a-4d50d6d8d1bc",
          },
          {
            value: "Egyptian Numeral",
            id: "1b8e5d85-bc7e-4330-97a6-8f2184f113b5",
          },
        ],
        solvedText: "Egyptian numbers",
        type: "text",
      },
      style: {},
      clues: [
        {
          dependsOn: [],
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          id: "4355b89b-607b-44c7-b1aa-84eb6077662a",
          clueGroup: 1,
          clueValues: [
            {
              type: "text",
              id: "6a744b78-e69c-401b-8ec9-cde140b5d336",
              value: "Finger",
              subtext: "10 000",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText:
            "Finger meant the number 10 000 to the people who built the Pyramids of Giza",
        },
        {
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          id: "983e5713-dbf4-4aa3-b185-50f3cb3f5cdd",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          clueGroup: 1,
          helperText:
            "Tadpole meant the number 100 000 to the people who built the Pyramids of Giza",
          clueValues: [
            {
              id: "b521b053-7301-451f-8f64-adc655baf8dd",
              type: "text",
              subtext: "100 000",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Tadpole",
            },
          ],
        },
        {
          dependsOn: [],
          subtext: "",
          clueValues: [
            {
              id: "5f607f4a-1b9d-4b32-acf4-322894424245",
              type: "text",
              value: "Rope",
              subtext: "100",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "37739c80-f965-4ec0-9f84-a1b169f6c455",
          clueGroup: 1,
          style: {
            width: "calc(33% - 10px)",
          },
          helperText:
            "Rope meant the number 100 to the people who built the Pyramids of Giza",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
        },
      ],
      id: "f531e714-430a-461b-8e0a-7bf531c61895",
    },
  ],
};

export default puzzle;
